import api from '../services/api';

export const installationAPI = {
  create: async (data) => {
    const response = await api.post('/installation', data);
    return response.data;
  },

  getAll: async (page = 1, limit = 10) => {
    const response = await api.get('/installations', {
      params: { page, limit }
    });
    return response.data;
  },

  getByUniqueId: async (uniqueId) => {
    const response = await api.get(`/installation/${uniqueId}/configs`);
    return response.data;
  },

  update: async (uniqueId, data) => {
    const response = await api.put(`/installation/${uniqueId}`, data);
    return response.data;
  },

  delete: async (uniqueId) => {
    const response = await api.delete(`/installation/${uniqueId}`);
    return response.data;
  },

  activate: async (data) => {
    const response = await api.post('/installation/activate', data);
    return response.data;
  }
};